import { useEffect, useState } from "react";
import { bannerCopy, readConsent, writeConsent } from "../utils/consent";
import { ensureKlaviyoScript } from "../utils/klaviyo";

const barStyle = {
  position: "fixed",
  zIndex: 10000,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  flexWrap: "wrap",
  gap: 12,
  alignItems: "center",
  justifyContent: "space-between",
  padding: "16px 20px",
  background: "#fff",
  borderTop: "1px solid #e6ddff",
  boxShadow: "0 -4px 16px rgba(0,0,0,0.08)",
};

const buttonStyle = {
  minHeight: 44,
  minWidth: 96,
  padding: "8px 16px",
  borderRadius: 8,
  fontWeight: 700,
  cursor: "pointer",
};

export default function ConsentBanner() {
  const [choice, setChoice] = useState(undefined);

  useEffect(() => {
    const current = readConsent();
    setChoice(current);
    if (current === "accepted") ensureKlaviyoScript();
  }, []);

  if (choice !== null) return null;
  const copy = bannerCopy();

  return (
    <div role="dialog" aria-live="polite" style={barStyle}>
      <p style={{ margin: 0, flex: "1 1 240px" }}>{copy.body}</p>
      <div style={{ display: "flex", gap: 8 }}>
        <button
          type="button"
          style={{ ...buttonStyle, background: "#fff", color: "#360882", border: "1px solid #360882" }}
          onClick={() => {
            writeConsent("rejected");
            setChoice("rejected");
          }}
        >
          {copy.reject}
        </button>
        <button
          type="button"
          style={{ ...buttonStyle, background: "#360882", color: "#fff", border: "1px solid #360882" }}
          onClick={() => {
            writeConsent("accepted");
            setChoice("accepted");
            ensureKlaviyoScript();
          }}
        >
          {copy.accept}
        </button>
      </div>
    </div>
  );
}
